import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/nurseryApi";
import { marked } from "marked";
import { Leaf, ArrowLeft, Calendar, ArrowRight } from "@phosphor-icons/react";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setErr("Post not found"));
  }, [slug]);

  return (
    <div className="organic-bg" style={{ minHeight: "100vh" }}>
      <header style={{ background: "rgba(250, 247, 239, 0.85)", backdropFilter: "saturate(160%) blur(10px)", position: "sticky", top: 0, zIndex: 30, borderBottom: "1px solid var(--border)" }}>
        <div style={{ maxWidth: 1280, margin: "0 auto", padding: "16px 24px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Link to="/" style={{ textDecoration: "none", display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 38, height: 38, background: "var(--primary)", borderRadius: 12, display: "grid", placeItems: "center" }}>
              <Leaf size={20} color="white" weight="fill" />
            </div>
            <div>
              <div className="font-display" style={{ fontSize: 20, lineHeight: 1 }}>NurserySense</div>
              <div style={{ fontSize: 11, color: "var(--muted-fg)", marginTop: 2 }}>Field Notes</div>
            </div>
          </Link>
          <Link to="/blog" className="btn btn-ghost"><ArrowLeft size={14} weight="bold" /> All posts</Link>
        </div>
      </header>

      {err && (
        <div style={{ padding: 80, textAlign: "center" }}>
          <h2 className="font-display" style={{ fontSize: 36 }}>{err}</h2>
          <Link to="/blog" className="btn btn-primary" style={{ marginTop: 18 }}>Back to blog</Link>
        </div>
      )}

      {post && (
        <article style={{ maxWidth: 760, margin: "0 auto", padding: "48px 24px 80px" }} data-testid="blog-post">
          <Link to="/blog" style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: "var(--secondary)", textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 6 }}>
            <ArrowLeft size={12} weight="bold" /> Field Notes
          </Link>
          <span className="badge badge-soft" style={{ marginTop: 18, marginRight: 8 }}>{post.tag}</span>
          <h1 className="font-display" style={{ fontSize: "clamp(40px, 6vw, 64px)", marginTop: 14, lineHeight: 1.05, letterSpacing: "-0.02em" }}>{post.title}</h1>
          <p style={{ fontSize: 19, color: "var(--text-soft)", marginTop: 18, lineHeight: 1.5 }}>{post.excerpt}</p>
          <div style={{ marginTop: 18, display: "flex", alignItems: "center", gap: 10, fontSize: 13, color: "var(--muted-fg)" }}>
            <Calendar size={13} weight="bold" /> {new Date(post.created_at).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" })}
            <span>·</span>
            <span>{post.author}</span>
          </div>
          {post.cover_image && (
            <div style={{ marginTop: 28, borderRadius: 18, overflow: "hidden", boxShadow: "var(--shadow-md)" }}>
              <img src={post.cover_image} alt={post.title} style={{ width: "100%", maxHeight: 460, objectFit: "cover", display: "block" }} />
            </div>
          )}
          <div className="post-prose" style={{ marginTop: 32 }} dangerouslySetInnerHTML={{ __html: marked.parse(post.body) }} />

          <div className="card" style={{ marginTop: 56, padding: 32, background: "linear-gradient(135deg, var(--primary), #3F5640)", color: "white", border: "none", textAlign: "center" }}>
            <h3 className="font-display" style={{ fontSize: 32, color: "white" }}>Want to try it on your nursery?</h3>
            <p style={{ fontSize: 15, color: "#dceadc", marginTop: 10 }}>2-week free field test. No card. Setup in 20 min.</p>
            <Link to="/register" className="btn" style={{ background: "var(--accent)", color: "var(--text)", marginTop: 20 }}>
              Apply for a founding slot <ArrowRight size={16} weight="bold" />
            </Link>
          </div>
        </article>
      )}

      <style>{`
        .post-prose h2 { font-family: 'DM Serif Display', serif; font-size: 32px; margin: 36px 0 14px; line-height: 1.15; letter-spacing: -0.01em; }
        .post-prose h3 { font-family: 'DM Serif Display', serif; font-size: 24px; margin: 28px 0 10px; }
        .post-prose p { font-size: 17.5px; line-height: 1.75; margin: 16px 0; color: var(--text-soft); }
        .post-prose ul, .post-prose ol { padding-left: 24px; margin: 16px 0; }
        .post-prose li { font-size: 17.5px; line-height: 1.75; margin: 8px 0; color: var(--text-soft); }
        .post-prose strong { color: var(--text); font-weight: 700; }
        .post-prose a { color: var(--secondary); text-decoration: underline; }
        .post-prose blockquote { border-left: 3px solid var(--secondary); padding-left: 18px; margin: 22px 0; font-style: italic; color: var(--text-soft); }
        .post-prose code { background: var(--muted); padding: 2px 6px; border-radius: 4px; font-size: 0.9em; }
      `}</style>
    </div>
  );
}
